import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <section {...{
      "className": "section-lead"
    }}><p parentName="section">{`To set a `}<inlineCode parentName="p">{`ReturnShipmentState`}</inlineCode>{`, the Order needs to have the `}<a parentName="p" {...{
          "href": "/api/../api/projects/orders#returninfo"
        }}>{`ReturnInfo`}</a>{` set with at least one `}<a parentName="p" {...{
          "href": "/api/../api/projects/orders#returnitem"
        }}>{`ReturnItem`}</a>{`.`}</p>
      <ul parentName="section">
        <li parentName="ul"><inlineCode parentName="li">{`action`}</inlineCode>{` - String - `}<inlineCode parentName="li">{`"setReturnShipmentState"`}</inlineCode></li>
        <li parentName="ul"><inlineCode parentName="li">{`returnItemId`}</inlineCode>{` - String - ID of the concerning `}<a parentName="li" {...{
            "href": "/api/../api/projects/orders#returnitem"
          }}>{`ReturnItem`}</a></li>
        <li parentName="ul"><inlineCode parentName="li">{`shipmentState`}</inlineCode>{` - `}<a parentName="li" {...{
            "href": "/api/../api/projects/orders#returnshipmentstate"
          }}>{`ReturnShipmentState`}</a>{` - New ReturnShipmentState according to `}<a parentName="li" {...{
            "href": "/api/../api/projects/orders#returnshipmentstate"
          }}>{`allowed transitions`}</a></li>
      </ul>
      <p parentName="section">{`This update action produces an `}<a parentName="p" {...{
          "href": "/api/../api/projects/messages#order-return-shipment-state-changed"
        }}>{`OrderReturnShipmentStateChanged`}</a>{` Message.`}</p>
    </section>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      